// App-wide error boundary. A render crash anywhere unmounts the whole React
// tree to a blank screen otherwise — this catches it and shows a recoverable
// message (with the error, so issues are diagnosable instead of invisible).

import { Component, type ErrorInfo, type ReactNode } from 'react';

interface State { error: Error | null }

export class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    // eslint-disable-next-line no-console
    console.error('LakayCart render error:', error, info.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50 px-4">
        <div className="w-full max-w-md bg-white border border-slate-200 rounded-2xl shadow-sm p-8 text-center">
          <div className="text-[20px] font-bold text-brand-700">Lakay<span className="text-amber-500">Cart</span></div>
          <p className="mt-4 text-[15px] font-semibold text-slate-900">Something went wrong on this page</p>
          <p className="mt-1 text-[12px] text-slate-500 break-words">{this.state.error.message}</p>
          <div className="mt-4 flex items-center justify-center gap-2">
            <button onClick={() => { this.setState({ error: null }); window.location.reload(); }} className="px-4 py-2 rounded-md bg-brand-600 text-white text-[13px] font-semibold hover:bg-brand-700">Reload</button>
            <a href="/" className="px-4 py-2 rounded-md border border-slate-200 text-slate-700 text-[13px] font-semibold hover:bg-slate-50">Home</a>
          </div>
        </div>
      </div>
    );
  }
}
